var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceAndTechnologyMobilePhoneAndInternet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3880.000000, -772.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device-and-technology/Mobile-phone-and-internet",
    transform: "translate(3880.000000, 772.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,3 L26,9 L23,9 L23,6 L3,6 L3,20 L19,20 L19,24 L0,24 L0,6 C0,4.343 1.343,3 3,3 L26,3 Z M26.844,28.182 C26.166,28.182 25.616,27.632 25.616,26.954 C25.616,26.277 26.166,25.728 26.844,25.728 C27.522,25.728 28.071,26.277 28.071,26.954 C28.071,27.632 27.522,28.182 26.844,28.182 L26.844,28.182 Z M23.2,11 C21.985,11 21,12.007 21,13.25 L21,29 L29.8,29 C31.016,29 32,27.992 32,26.75 L32,11 L23.2,11 Z M13,26 C10.761,26 8.702,26.599 7,27.596 L7,29 L19,29 L19,27.596 C17.3,26.599 15.239,26 13,26 L13,26 Z",
    id: 132
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceAndTechnologyMobilePhoneAndInternet);
export default __webpack_public_path__ + "static/media/device-and-technology-mobile-phone-and-internet.a79acce1.svg";
export { ForwardRef as ReactComponent };